<template>
  <div class="text-center">
    <div class="md-auto">
      <h1 class="text-primary">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>
      </h1>
    </div>
  </div>
  <!---->
</template>
<script>
export default {
  data: function () {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
.spinner {
  width: 75px;
  height: 75px;

  position: relative;
  margin: 100px auto;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce1 {
  background-color: #097797;
}

.double-bounce2 {
  -webkit-animation-delay: -0.6s;
  animation-delay: -0.6s;

  background-color: #26ac83;
}

@-webkit-keyframes sk-bounce {
  0% {
    -webkit-transform: scale(0);
  }
  75%,
  100% {
    -webkit-transform: scale(1);
    opacity: 0;
  }
}

@keyframes sk-bounce {
  0% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  75%,
  100% {
    transform: scale(1);
    -webkit-transform: scale(1);
    opacity: 0;
  }
}
</style>
